import React, { useEffect, useRef, useState } from 'react';
import { Input, InputRef } from 'antd';
import { IMask, MaskPropsKeys, ReactMaskProps, useIMask } from 'react-imask';

// type MaskOptionsType = Omit<Parameters<typeof IMask>[1], 'lazy'>
type MaskOptionsType = Parameters<typeof IMask>[1]

type InputValueType = string;

interface IRequiredAntdControllerProps {
  id?: string;
  value?: InputValueType;
  onChange?: (value: InputValueType) => void,
  onBlur?: React.FocusEventHandler<HTMLInputElement>,
  onSubmit?: React.FormEventHandler<HTMLInputElement>,
  disabled?: boolean
}

interface MyCustomControllerProps extends IRequiredAntdControllerProps {
  maskOptions: MaskOptionsType,
  placeholder?: string,
  unmask?: boolean
}

export const InputComReactIMask: React.FC<MyCustomControllerProps> = (props) => {
  const [privateValue, setPrivateValue] = useState<InputValueType>();
  const [establishedMask, setEstablishedMask] = useState<ReturnType<typeof IMask>>();

  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    establishedMask?.updateValue();
  })

  useEffect(() => {
    if(establishedMask){
      establishedMask.updateValue();
      return;
    }

    if (inputRef.current && inputRef.current.input) {
      const mask = IMask(
        inputRef.current.input,
        props.maskOptions
      )

      /* Não é uma redundância com o 'onInputValueChanged' */
      inputRef.current.input?.addEventListener("change", (e) => {
        if (mask.value != privateValue || mask.value != props.value) {
          if (!mask.value) return;

          setPrivateValue(mask.value);
          props.onChange?.(mask.value);

          mask?.updateValue();
        }
      })

      setEstablishedMask(mask);
    }
  }, [inputRef])

  const onInputValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    setPrivateValue(newValue);
    props.onChange?.(newValue);
  };

  return (
    <span id={props.id}>
      <Input
        type="text"
        value={props.value || privateValue}
        onChange={onInputValueChange}
        onBlur={props.onBlur}
        onSubmit={props.onSubmit}
        disabled={props.disabled}

        placeholder={( () => { 
          if(props.placeholder) return props.placeholder;

          const m = (props.maskOptions as any).mask;
          if(typeof m == 'string'){
            return m
          }

          return undefined;
        })()} 
        ref={inputRef}
      />
      
    </span>
  );
};

// export const useInputComReactIMask: React.FC<MyCustomControllerProps> = (props) => {
//   const [privateValue, setPrivateValue] = useState<InputValueType>();
//   const [establishedMask, setEstablishedMask] = useState<ReturnType<typeof IMask>>();

//   const inputRef = useRef<InputRef>(null);

//   useEffect(() => {
//     establishedMask?.updateValue();
//   })

//   useEffect(() => {
//     if(establishedMask){
//       establishedMask.updateValue();
//       return;
//     }

//     if (inputRef.current && inputRef.current.input) {
//       const mask = IMask(
//         inputRef.current.input,
//         props.maskOptions
//       )

//       /* Não é uma redundância com o 'onInputValueChanged' */
//       inputRef.current.input?.addEventListener("change", (e) => {
//         if (mask.value != privateValue || mask.value != props.value) {
//           if (!mask.value) return;

//           setPrivateValue(mask.value);
//           props.onChange?.(mask.value);

//           mask?.updateValue();
//         }
//       })

//       setEstablishedMask(mask);
//     }
//   }, [inputRef])

//   const onInputValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const newValue = e.target.value;

//     setPrivateValue(newValue);
//     props.onChange?.(newValue);
//   };

//   return (
//     <span id={props.id}>
//       <Input
//         type="text"
//         value={props.value || privateValue}
//         onChange={onInputValueChange}
//         onBlur={props.onBlur}
//         onSubmit={props.onSubmit}
//         disabled={props.disabled}

//         placeholder={( () => { 
//           if(props.placeholder) return props.placeholder;

//           const m = (props.maskOptions as any).mask;
//           if(typeof m == 'string'){
//             return m
//           }

//           return undefined;
//         })()} 
//         ref={inputRef}
//       />
      
//     </span>
//   );
// };
